/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import update from 'immutability-helper';

import * as types from '../constants/ActionTypes';

const getInitialState = () => ({
  open: false,
});

const initialState = getInitialState();

const CredentialsDialog = (state = initialState, action) => {
  switch (action.type) {
    case types.OPEN_CREDENTIALS_DIALOG:
      return update(state, {
        $merge: {
          open: true,
          type: action.serviceType,
        },
      });
    case types.CLOSE_CREDENTIALS_DIALOG:
      return update(state, {
        $merge: {
          open: false,
          type: null,
        },
      });
    default:
      return state;
  }
};

export default CredentialsDialog;
